// Hilfsfunktionen zur Abbildung zwischen Anzeige-Units und API-Units
// Anzeige-Units (Frontend): Stk., kg, to.
// Backend-Units (API): PIECE, KG, TO

export type DisplayUnit = 'Stk.' | 'kg' | 'to.';
export type ApiUnit = 'PIECE' | 'KG' | 'TO';

export function mapUnitForApi(display?: DisplayUnit): ApiUnit | undefined {
  if (!display) return undefined;
  switch (display) {
    case 'Stk.': return 'PIECE';
    case 'kg': return 'KG';
    case 'to.': return 'TO';
    default: return undefined;
  }
}

export function mapUnitForDisplay(api?: string): DisplayUnit | undefined {
  if (!api) return undefined;
  switch (api.toLowerCase()) {
    case 'piece': return 'Stk.';
    case 'kg': return 'kg';
    case 'to': return 'to.';
    default: return undefined; // unbekannte Werte verwerfen
  }
}

export function normalizeProductUnitsForApi<T extends { unit?: DisplayUnit }>(p: T): Omit<T, 'unit'> & { unit?: ApiUnit } {
  return { ...(p as any), unit: mapUnitForApi(p.unit) };
}

export function normalizeProductUnitsFromApi<T extends { unit?: string }>(p: T): Omit<T, 'unit'> & { unit?: DisplayUnit } {
  return { ...(p as any), unit: mapUnitForDisplay(p.unit) };
}

export function ensureDisplayUnit(raw: string): DisplayUnit {
  const allowed: DisplayUnit[] = ['Stk.', 'kg', 'to.'];
  return (allowed.includes(raw as DisplayUnit) ? raw as DisplayUnit : 'Stk.');
}
